/**
 * Añade a los elementos identificados por selector ('.ejemplo', '#ejemplo', etc) un tooltip
 * cuyo contenido sea el atributo 'attr' (por defecto, title="xxx").
 * @param {string} selector
 * @param {string} attr
 * @return {Promise<void>}
 */
export const tippy = async (selector, attr) => {
    if (typeof selector === 'undefined') {
        selector = '.tippy-tooltip';
    }

    if (typeof attr === 'undefined') {
        attr = 'title';
    }

    const elements = document.querySelectorAll(selector);
    if (elements) {
        const tippy = await import('tippy.js');
        await import('tippy.js/dist/tippy.css');

        elements.forEach(item => {
            tippy.default(item, {
                arrow: true,
                animation: 'scale',
                interactive: 'true',
                content: item.getAttribute(attr)
            });
        })
    }
}

